module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title"
  }, [_c('a', [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When"), _c('a', {
    attrs: {
      "id": "p1"
    }
  }, [_vm._v(" my father died in 2004, aged 105, he left behind this manuscript, with a letter saying that I could publish it if I wished to.")])]), _c('a', {
    attrs: {
      "id": "p1"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I don’t see why not, though I will call it a work of fiction, or of wishing, rather than a memoir. Much of it is impossible to believe, though it is presented as fact. I am of an age myself, 77 this month, able to appreciate the fact that the membrane that separates memory from imagination is semipermeable at best.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s the story of Rosa Coleman, my father’s mother, whom I knew as G-ma at the end of her long life. She was born before the Civil War.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "p1"
    }
  }, [_vm._v("G-ma ")]), _c('a', {
    attrs: {
      "id": "p2"
    }
  }, [_vm._v("told me many stories when I was a boy, but never this one. Her son, my famous father, never mentioned it either, understandably. His great fear was ending his days in an institution, and that is probably where he would have wound up if he had presented this as truth.")])]), _c('a', {
    attrs: {
      "id": "p2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("But Pops thought enough of it to go to some trouble and expense to have it typed up and carefully preserved.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She was a sweet woman, the joy of my childhood, and I offer her story here with respect and no further comment.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_vm._v("—Blake Coleman")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_vm._v("21 March 2005")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dbcbfc8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/prologue.vue
// module id = 72
// module chunks = 0